import React,
       { useContext,
         useState,
         useEffect } from 'react';
import { withRouter,
         Redirect } from 'react-router-dom';
import { Typography, 
         Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { appContext } from "./index";
import { INFO, CONSTS } from '../util/object';
import { copyToClipboard } from "../util/util";
import { checkAuthResponse,
         AuthClass } from '../class/AuthClass';
import { NoticePWA } from "./Util";
import Login from './Login';
import Invite from './Invite';
import { SettingsInputCompositeRounded } from '@material-ui/icons';
//import { GATag, Stack } from "../util/tools";

var auth = new AuthClass();

const auth_useStyles = makeStyles(theme => ({
    auth_root: {
        display: 'flex',
        flexDirection: 'column',
        //maxHeight: '90vh', 
        //maxWidth: '60%',
        height: '100vh',
        maxWidth: '600px',
        minWidth: '300px',
        paddingTop: '2vh',
        overflow: 'auto',
        //backgroundColor:'#44ffff',
    },
    mask: {
        left: '0',
        top: '0',
        position: 'absolute',
        maxWidth: '100vw', 
        maxHeight: '100vh', 
        width: '100vw', 
        height: '100vh', 
        padding: '0',
        margin: '0',
        backgroundColor:'#e1eaf5',
        zIndex: '100',
    },
    main: {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: '75vh', 
        padding: '0',
        //overflow: 'auto',    // enable scroll
        //height: '100vh'
        //backgroundColor:'#ff00ff',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-around',
        padding: '0',
        paddingTop: '1vh',
        fontSize: '2.0rem',
        fontWeight: 'bold',
        color: '#192a86',
        textAlign: 'center',
        //backgroundColor: 'rgba(255, 255, 255, 0.9)',
    },
    logo: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: '1vh',
        marginBottom: '1vh',
        justifyContent: 'center',
    },
    footer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        padding: theme.spacing(1),
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
    },
    hidden: {
        display: "none",
    }
}));

const Auth = (props) => {
    const classes = auth_useStyles();
    const { State, Dispatch } = useContext(appContext);
    function setState(name, value) {
        //console.log("setState:  ",name," =", value, " @", Stack(new Error().stack));
        Dispatch({ type: [name], value: value });   // reducer wrapper
    }
    const [ ShowInvite, setShowInvite ] = useState(true);
    const [ Title, setTitle ] = useState("AXOS");
    const [ ShowMask, setShowMask ] = useState(true);
    const [ AuthCheckTimer, setAuthCheckTimer ] = useState(null);
    const [ ShowUseSafari, setShowUseSafari ] = useState(false);
    const [ NoticeType, setNoticeType ] = useState(null);
    const [ Copied, setCopied ] = useState(false);

    useEffect(() => {
        // use target_path if nothing passed in to prop.to, then go to /console if no ep
        var path = (props.to === null) ? State.target_path : props.to;
        path = (State.entry_path !== null) ? State.entry_path : path;
        //console.log("############## Auth.INIT.1: props=", props, " State=", State);
        //console.log("############## Auth.INIT.2: invite=", State.invite_mode, " target=", State.target_path, " to=",props.to, " path=",path);
        if(props.logout === true) {
            console.log("Auth.INIT.87: ################# process logout... path=", path)
            auth.logout('/auth', State, setState);  // TODO: use passed in
        }

        //setState('target_path', props.return);
        if((State.splash_done === false) && (State.authed === false)) {
            console.log("Auth.INIT.92: ################# starting checkAuthResponse() ...");
            checkAuthResponse(State, setState, "auth.97");  // stale page, still redir
        }

        if(false || (INFO.pwa_install_state === CONSTS.PWA_USE_SAFARI)) {

            setNoticeType(CONSTS.PWA_USE_SAFARI);
            //setNoticeType(INFO.pwa_install_event);
            setShowUseSafari(true);
        }

        setShowInvite(INFO.show_invite);
        setState("show_progress", false);
        INFO.show_login_progress = false;

        {(State.has_login) ?
            setTitle("SIGN IN")
            :
            setTitle("WELCOME")
        }

        var mask_timer = setTimeout(()=> {
            setShowMask(false);
        },  CONSTS.AUTH_DISPLAY_DELAY);

        window.addEventListener('check_login', handleCheckLogin, false); // redirect to next stage
        return function cleanup() {
            console.log("login.229: ****** CLEAN UP LEAVING <AUTH> ...", Date.now()%100000/1000);
            window.removeEventListener('check_login', handleCheckLogin, false); // Listen for the event and write session to fb
            if (AuthCheckTimer !== null){
                clearTimeout(AuthCheckTimer);
            }

            clearTimeout(mask_timer);
        }

    }, [1]);

    useEffect(() => {
        if (State.authed === true) {
            console.log("Auth.INIT.3: State.authed changed! "+State.authed);
            //setState('show_redirect', true);
        }
    }, [State.authed, State.refresh_display, ShowInvite ]);



    // KLUDGE: Keep checking until login response comes in
    //
    const handleCheckLogin = () => {
        var auth_check_timer = setTimeout(()=> {
            //console.log("Auth.152:       TIMER WAKEUP:  CHECK Auth Response ", Date.now());
            checkAuthResponse(State, setState, "auth.153.timer");
            //checkAuthResponse.bind(this, State, setState, "auth.154.timer");      // DOES NOT WORK!  why?
            //window.dispatchEvent(INFO.check_login_event);
        },  CONSTS.AUTH_CHECK_DELAY);

        setAuthCheckTimer(auth_check_timer);
    }


    const handleRegister = e => {
        //GATag("Onboarding", "Register.ShowPasswordClick", ShowPassword, 0);		 // (cat, act, lab, val)
        console.log("Auth.INIT.108: Start Registration   show_invite="+State.show_invite);
        setShowInvite(false);
        setTitle("REGISTRATION")
    }

    const handleLogin = e => {
        //GATag("Onboarding", "Register.ShowPasswordClick", ShowPassword, 0);		 // (cat, act, lab, val)
        console.log("Auth.INIT.108: Start Login   show_invite="+State.show_invite);
        setShowInvite(false);
        setTitle("AXOS LOGIN")
    }


    const handleCopyAction = e => {
        //GATag("Onboarding", "Register.ShowPasswordClick", ShowPassword, 0);		 // (cat, act, lab, val)
        var ele = document.getElementById("copy_target");   // KLUDGE: NOT HERE, MOVE DOWN
        var copied = copyToClipboard(ele);
        console.log("Auth.Copy.190:   COPY URL PATH....", copied);
        setCopied(true);
    }


    const renderRedirect = () => {
      if (State.show_redirect) {
        //var target = '/splash';
        //if ((State.authed === true) && (INFO.redirect_path !== null)) {
        if (State.authed === true) {
            //target = (State.invite_mode) ? State.target_path : State.entry_path;
            //console.log("############## Auth.renderRedirect: AUTHED  invite=", State.invite_mode, " target=", State.target_path, " entry=", State.entry_path);
            console.log("############## Auth.renderRedirect.161: AUTHED  REDIRECT PATH=", INFO.redirect_path);
            return <Redirect to={INFO.redirect_path} />
        }
        //console.log("auth.113:  ################### Auth.renderRedirect: set path="+target, " authed=", State.authed)
//setState('show_redirect', false)

      }
    }


    return (
        <React.Fragment>
            { ShowMask && <div id="mask" className={classes.mask} /> }
            <Container id="auth" fixed className={classes.auth_root} >

                <Typography className={classes.header}> {Title} </Typography>
                <Container className={classes.main} >
                    {(ShowUseSafari === true) ?
                        <NoticePWA Type={NoticeType}
                                Style={{position: "absolute", top: "50px", left: "0px"}}
                                Copied={Copied}
                                Copy={handleCopyAction}  />
                    :
                        (ShowInvite === true) ?
                            <Invite Login={handleLogin} Register={handleRegister} {...props} />
                        :
                            <Login {...props} />
                    }
                </Container>

            </Container>

            {renderRedirect()}
        </React.Fragment>)
}

export default withRouter(Auth);